export { default } from '@material-ui/core/Fab';

export type FabProps = import('@material-ui/core/Fab').FabProps;
